import * as React from "react";
import Modal from "../../ui/modal/Modal";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";
import FormButtonsView from "../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * Send message button click callback.
	 * @param {string} value
	 */
	onMessageSend: (value: string) => void;
	/**
	 * Close modal callback.
	 */
	onClose: () => void;
	/**
	 * Modal title
	 */
	title: string;
}

interface IState {
	/**
	 * Message content.
	 */
	messageText: string;
}

type Props = IComponentProps

export default class MessageModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {
			messageText: ""
		};
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={this.props.title}>
				<TextArea onChange={this.onChange}
						  hasBorder={true}
						  value={this.state.messageText}
						  placeholder={"Message text"}
						  rows={5}
						  focus/>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel"
											onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Send"}
									   onClick={() => this.props.onMessageSend(this.state.messageText)}
									   disabled={!this.state.messageText.length}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}

	private onChange(evt: React.ChangeEvent<HTMLTextAreaElement>) {
		this.setState({messageText: evt.target.value});
	}
}